/**
 * 数据结构序列化&反序列化
 */

export const Serialize = (data: object, firstCon = '&', secondCon = '=') => {
  return Object.keys(data).reduce((prev, key) => {
    const value = data[key];
    if (value != null) {
      prev += (prev && firstCon) + encodeURIComponent(key) + (String(value) && secondCon + encodeURIComponent(value));
    }
    return prev;
  }, '');
};
interface Dictionary<T> {
  [key: string]: T;
}
export const Deserialize = (value: string, firstCon = '&', secondCon = '=') => {
  const result: Dictionary<string> = {};
  return value.replace('?', '').split(firstCon).reduce((prev, elem) => {
    const index = elem.indexOf(secondCon);
    if (index === -1) {
      prev[elem] = '';
    } else {
      prev[elem.slice(0, index)] = elem.slice(index + 1);
    }
    return prev;
  }, result);
};

export const TransformObject = (list: [], key = 'value', value = 'label') => {
  const res: Dictionary<any> = {};
  return list.reduce((prev, elem) => {
    prev[elem[key]] = elem[value];
    return prev;
  }, res);
};

export const TransformEnumArray = (list: [], value = 'value', label = 'label') => {
  const res: Object[] = [];
  return list.reduce((prev, elem) => {
    prev.push({ value: elem[value], label: elem[label] });
    return prev;
  }, res);
};

export const TransfromObjectToArray = (obj) => {
  if (typeof obj !== 'object') {
    return [];
  }
  const res: any[] = [];
  Object.keys(obj).forEach((i) => {
    res.push(obj[i]);
  });
  return res;
};
